<template>
    <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13.7656 12.7188C14.0469 13.0312 14.0469 13.5 13.7656 13.7812C13.4531 14.0938 12.9844 14.0938 12.7031 13.7812L9.01562 10.0625L5.29688 13.7812C4.98438 14.0938 4.51562 14.0938 4.23438 13.7812C3.92188 13.5 3.92188 13.0312 4.23438 12.7188L7.95312 9L4.23438 5.28125C3.92188 4.96875 3.92188 4.5 4.23438 4.21875C4.51562 3.90625 4.98438 3.90625 5.26562 4.21875L9.01562 7.96875L12.7344 4.25C13.0156 3.9375 13.4844 3.9375 13.7656 4.25C14.0781 4.53125 14.0781 5 13.7656 5.3125L10.0469 9L13.7656 12.7188Z" />
    </svg>
</template>